export default __webpack_public_path__ + "static/media/icon_avatar_checked.5876cf2d.svg";